export function timeAgo(iso) {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  const diff = Math.max(0, Date.now() - then);
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min${mins > 1 ? "s" : ""} ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} hr${hrs > 1 ? "s" : ""} ago`;
  const days = Math.floor(hrs / 24);
  return `${days} day${days > 1 ? "s" : ""} ago`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString(undefined, {
    year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
  });
}

export function fmtNum(n, opts = {}) {
  if (n == null || isNaN(n)) return "—";
  const abs = Math.abs(n);
  let digits = opts.digits;
  if (digits == null) {
    if (abs >= 1000) digits = 2;
    else if (abs >= 1) digits = 4;
    else digits = 6;
  }
  return Number(n).toLocaleString(undefined, {
    minimumFractionDigits: opts.min ?? 2,
    maximumFractionDigits: digits,
  });
}

export function fmtPrice(n) {
  if (n == null || isNaN(n)) return "—";
  const abs = Math.abs(n);
  const digits = abs >= 1 ? 2 : abs >= 0.01 ? 4 : 6;
  return "$" + Number(n).toLocaleString(undefined, {
    minimumFractionDigits: 2, maximumFractionDigits: digits,
  });
}

export function fmtCompact(n) {
  if (n == null || isNaN(n)) return "—";
  return "$" + Number(n).toLocaleString(undefined, { notation: "compact", maximumFractionDigits: 2 });
}

export function fmtPct(n) {
  if (n == null || isNaN(n)) return null;
  return `${n >= 0 ? "+" : ""}${n.toFixed(2)}%`;
}

// Display-layer helpers for a comma-separated numeric text input (raw value kept unformatted)
export function parseAmountInput(val) {
  let cleaned = String(val).replace(/,/g, "").replace(/[^0-9.]/g, "");
  const parts = cleaned.split(".");
  if (parts.length > 2) cleaned = parts[0] + "." + parts[1];
  return cleaned;
}

export function formatAmountInput(raw) {
  if (raw === "" || raw == null) return "";
  const [intPart, decPart] = String(raw).split(".");
  const intNum = intPart === "" ? "" : Number(intPart).toLocaleString("en-US");
  return decPart !== undefined ? `${intNum || "0"}.${decPart}` : intNum;
}

const SYMBOLS = { USD: "$", EUR: "€", GBP: "£", JPY: "¥", CNY: "¥", INR: "₹", AUD: "A$", CAD: "C$", CHF: "CHF ", KRW: "₩", BRL: "R$" };

export function fmtMoney(n, base = "USD") {
  if (n == null || isNaN(n)) return "—";
  const abs = Math.abs(n);
  const digits = abs >= 1 ? 2 : abs >= 0.01 ? 4 : 6;
  const num = Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: digits });
  const sym = SYMBOLS[base];
  return sym ? `${sym}${num}` : `${num} ${base}`;
}

export function fmtCompactBase(n, base = "USD") {
  if (n == null || isNaN(n)) return "—";
  const num = Number(n).toLocaleString(undefined, { notation: "compact", maximumFractionDigits: 2 });
  const sym = SYMBOLS[base];
  return sym ? `${sym}${num}` : `${num} ${base}`;
}
